import './CorporateRProgram.css'

import { SlCalender } from "react-icons/sl";
import { BsCalendarDate } from "react-icons/bs";
import { GrUserSettings } from "react-icons/gr";
import { BsBuildings } from "react-icons/bs";
import CorporateRProgramCard from './CorporateRProgramCard';

const programData = [
    {
        id: 1,
        icon: SlCalender,
        title: 'Team Building + Theme Events',
        description: 'Fun, engaging activities that foster teamwork and belonging.',
    },
    {
        id: 2,
        icon: BsCalendarDate,
        title: 'Monthly/Quarterly Fun Days',
        description: 'Regularly scheduled events to build connections and uplift team spirit',
    },
    {
        id: 3,
        icon: GrUserSettings,
        title: 'Fully Managed, No HR Hassle',
        description: 'Our team handles every aspect, making planning seamless for you.',
    },
    {
        id: 4,
        icon: BsBuildings,
        title: 'Custom to Your Company Size & Vibe',
        description: 'Tailor your experience for the needs and culture of your team.',
    },
];


export default function CorporateRProgram() {
    return (
        <>
            <div className='corporate-r-program-section'>
                <div className="container">
                    <div className="corporate-r-pro-wrapper">
                        <div className='corporate-r-pro-text'>
                            <h1>The Corporate Recreation Program: Your Culture Catalyst</h1>
                        </div>
                        <div className='corporate-r-pro-card-section'>
                            {programData.map(({ id, icon, title, description }) => (
                                <CorporateRProgramCard
                                    key={id}
                                    icon={icon}
                                    title={title}
                                    description={description}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
